import {Component, Injector, Input, ViewEncapsulation} from '@angular/core';
import {Module} from "../../model/ModuleModel";
import {MapModuleModel} from "./map-module.model";
import { UpaTarget, UpaTrackingData} from "../../services/upa.service";
import { AbstractComponent } from '../abstract.component';

@Component({
  selector: 'map-module',
  template: `
    <div class="eva-3-card">
      <pois-miniature-map [product]="product" [flow]="flow"
                          [mapType]="module.data.map_type"
                          [apiKey]="module.data.api_key"
                          [mainMarker]="module.data.main_marker"
                          [poiCategories]="module.data.poi_categories"
                          [title]="module.data.title"
                          [modalTitle]="module.data.modal_title"
                          [description]="module.data.description"
                          [secondaryDescription]="module.data.secondary_description"
                          [locale]="module.data.locale"
                          (onMapOpen)="onMapOpen()"
      ></pois-miniature-map>
    </div>
  `,
  styleUrls: ['./map-module.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MapModuleComponent extends AbstractComponent {
  public static MODULE_ID: string = 'HotelMapModule';
  @Input() override product: string;
  @Input() override flow: string;
  @Input() override module: Module<MapModuleModel>
  
  constructor(injector: Injector) {
    super(injector);
   }

  onMapOpen() {
    const upaData: UpaTrackingData = {
      moduleId: this.module.id,
      moduleIndex: this.module.row_number,
      target: UpaTarget.MAP,
      label: 'view-on-map',
      uniqueId: this.module.unique_id
    }
    this.upaService.trackClickTopic(upaData);
  }

  getModuleId(): string {
    return MapModuleComponent.MODULE_ID;
  }
}
